import React from 'react';
import PropTypes from 'prop-types';
import BodyClassName from 'react-body-classname';

export const NavWrapper = ({ children, isMobile }) =>
  isMobile ? (
    <BodyClassName className="body--hide-content">
      <div className="header__mobile-panel">{children}</div>
    </BodyClassName>
  ) : (
    <div className="header__nav">{children}</div>
  );

NavWrapper.propTypes = {
  isMobile: PropTypes.bool,
  children: PropTypes.node.isRequired,
};
